export default __webpack_public_path__ + "static/State_farm-0fadb47c3746c507653220b5e666ebd8.svg";